// extracted by mini-css-extract-plugin
var _1 = "ArrowButton-moduleArrowButton__u3nex";
var _2 = "ArrowButton-modulebtnWrapper__g3ywv IconNG-moduleiconContainer__SxWZ0";
var _3 = "ArrowButton-moduleleftBtn__JmKc0";
var _4 = "ArrowButton-modulerightBtn__KZtXK";
export { _1 as "ArrowButton", _2 as "btnWrapper", _3 as "leftBtn", _4 as "rightBtn" }
